import { getData } from "./commonServices";
import { ADMIN_DASHBOARD_STATS } from "../serviceUrls";

// Helper to get token from localStorage
const getToken = () => localStorage.getItem("access_token");

// Dashboard API Service
export const dashboardAPI = {
  // Get admin dashboard summary data
  getDashboardData: async () => {
    const token = getToken();
    return await getData(ADMIN_DASHBOARD_STATS, token);
  },

  // Get user dashboard data (role-based)
  getUserDashboard: async () => {
    const token = getToken();
    return await getData("user/dashboard", token);
  },
};
